import { useState } from 'react';
import './CalcRewards.css';
import { useUI } from '../../hooks/useUI';
import { resources } from '../../utils/resources';

const CalcRewards = ({ currencyName }) => {
    const { assetId, rewardValueName, userData } = useUI();
    const [inputValue, setInputValue] = useState('');
    const [isValid, setIsValid] = useState(true);

    const periods = [
        { label: '1 Hour', hours: 1 },
        { label: '1 Day', hours: 24 },
        { label: '1 Week', hours: 168 },
        { label: '2 Weeks', hours: 336 },
        { label: '1 Month', hours: 720 },
        { label: '3 Month', hours: 2160 },
        { label: '6 Month', hours: 4320 },
        { label: '1 Year', hours: 8760 },
        { label: '5 Years', hours: 43800 },
    ];

    function formatNumber(num) {
        if (num >= 1_000_000) {
            return (num / 1_000_000).toFixed(2).replace('.', ',') + 'М';
        }

        if (Number.isInteger(num)) {
            return num.toLocaleString('en');
        } else {
            return num.toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
    }

    function getLevelPercent(amount, levels) {
        let result;

        if (levels.length < 1) return;
        for (let level of levels) {
            if (amount >= level.minamount && amount < level.maxamount) {
                result = level.percent;
            }
        }

        if (!result && amount > levels[levels.length - 1].maxamount) {
            result = levels[levels.length - 1].percent;
        }

        return result;
    }

    const calculateReward = (hours) => {
        const balance = parseFloat(inputValue) || 0;
        const assetTier = userData?.staking_assets?.find(asset => asset.asset_id === assetId);

        if (!assetTier || !assetTier.asset_tier || !assetTier.asset_tier.levels) {
            console.warn(`Cannot calculate reward: assetTier, asset_tier, or levels missing for asset_id ${assetId}`);
            return 0;
        }

        return balance / 100 * getLevelPercent(balance, assetTier.asset_tier.levels) * hours;
    };

    const validateInput = (value) => {
        const num = parseFloat(value);
        return !isNaN(num) && num >= 0;
    };

    const handleInputChange = (e) => {
        const value = e.target.value;
        setInputValue(value);
        setIsValid(validateInput(value));
    };

    const handleSubmit = () => {
        if (isValid && inputValue !== '') {
            document.querySelector('.calcRewards__bottom').classList.add('active');
        }
    };

    // Проверка, заполнен ли инпут
    const isInputFilled = () => {
        return inputValue.trim() !== '';
    };

    // Обработчик нажатия Enter
    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && isInputFilled() && isValid) {
            handleSubmit();
            // Снимаем фокус с инпута
            document.activeElement.blur();
        }
    };

    return (
        <div className='calcRewards'>
            <div className="calcRewards__top">
                <input
                    type="text"
                    placeholder='Calculate reward'
                    className='calcRewards__input'
                    value={inputValue}
                    onChange={handleInputChange}
                    onKeyDown={handleKeyDown} // Добавляем обработчик Enter
                    style={{ border: isValid ? '' : '1px solid red' }}
                />
                <button className="calcRewards__btn" onClick={handleSubmit}>Submit</button>
            </div>
            <div className="calcRewards__bottom">
                {periods.map((period) => {
                    const result = calculateReward(period.hours);
                    const formattedResult = formatNumber(result);
                    const isLarge = result > 100000 && result < 1000000;

                    return (
                        <div className="calcRewards__item" key={period.label}>
                            <div className="calcRewards__week appearanceAnimation">{period.label}</div>
                            <div className="calcRewards__itemValue">
                                <div className="calcRewards__itemIcon">
                                    <img src={resources.icons.ethG} alt="" />
                                </div>
                                <span className="appearanceAnimation" style={isLarge ? { fontSize: '14px' } : {}}>
                                    {`${formattedResult} ${rewardValueName}`}
                                </span>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default CalcRewards;